(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3882],{

/***/ 13880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(79833);

/**
 * Replaces matches for `pattern` in `string` with `replacement`.
 *
 * **Note:** This method is based on
 * [`String#replace`](https://mdn.io/String/replace).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to modify.
 * @param {RegExp|string} pattern The pattern to replace.
 * @param {Function|string} replacement The match replacement.
 * @returns {string} Returns the modified string.
 * @example
 *
 * _.replace('Hi Fred', 'Fred', 'Barney');
 * // => 'Hi Barney'
 */
function replace() {
  var args = arguments,
      string = toString(args[0]);

  return args.length < 3 ? string : string.replace(args[1], args[2]);
}

module.exports = replace;


/***/ }),

/***/ 66370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ImagesGalleryComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _images_gallery_row_images_gallery_row_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99112);







var ImagesGalleryComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ImagesGalleryComponent, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ImagesGalleryComponent);
    function ImagesGalleryComponent() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, ImagesGalleryComponent);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(ImagesGalleryComponent, [
        {
            key: "convertToMatrixIfNeeded",
            value: function convertToMatrixIfNeeded(assets) {
                if (assets && !Array.isArray(assets[0])) {
                    return [
                        assets
                    ];
                }
                return assets;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, assets = _props.assets, shadow = _props.shadow, screenRatios = _props.screenRatios, grayscale = _props.grayscale, shouldTrackMouseEvents = _props.shouldTrackMouseEvents;
                assets = this.convertToMatrixIfNeeded(assets);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "images-gallery",
                    children: assets.map(function(assetsRow, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_images_gallery_row_images_gallery_row_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            grayscale: grayscale,
                            assets: assetsRow,
                            shadow: shadow,
                            screenRatios: screenRatios,
                            shouldTrackMouseEvents: shouldTrackMouseEvents
                        }, index);
                    })
                });
            }
        }
    ]);
    return ImagesGalleryComponent;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);

ImagesGalleryComponent.defaultProps = {
    assets: [],
    grayscale: false
};


/***/ }),

/***/ 49281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _logos_const__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83971);

/* harmony default export */ __webpack_exports__["Z"] = ({
    numberOfCompanies: _logos_const__WEBPACK_IMPORTED_MODULE_0__/* .NUMBER_OF_COMPANIES */ .X$,
    grayscale: false,
    showAllLogos: false,
    companyField: _logos_const__WEBPACK_IMPORTED_MODULE_0__/* .LOGO_COMPANY_FIELDS.GENERAL */ .QS.GENERAL,
    logosScale: 1,
    useSingleLine: false,
    paddingInlined: "0px"
});


/***/ }),

/***/ 89206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ logos; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/logos/logos-const.js
var logos_const = __webpack_require__(83971);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./segments/desktop/core-components/logos/default-props.js
var default_props = __webpack_require__(49281);
// EXTERNAL MODULE: ./components/core/images-gallery/images-gallery-component.js
var images_gallery_component = __webpack_require__(66370);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/logos/logos.scss.js


var LOGO_BIG_SCREEN_WIDTH = 150;
var LOGO_SMALL_SCREEN_WIDTH = 120;
var LOGO_SLIM_WIDTH = 72;
var LOGO_SLIM_HEIGHT = 35;
var LOGO_WIDTH_TOTAL_PADDING = 32;
var LOGO_BIG_SCREEN_HEIGHT = 69;
var LOGO_SMALL_SCREEN_HEIGHT = 50;
var StyledLogos = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "egj6ol80"
})("margin:auto;display:flex;justify-content:center;max-width:", function(props) {
    return props.maxWidth;
}, ";.image-gallery{transform:scale(", function(props) {
    return props.logosScale;
}, ");}.images-logos-wrapper{width:100%;}.images-gallery-row{display:flex;justify-content:center;flex-wrap:", function(props) {
    return props.useSingleLine ? "nowrap" : "wrap";
}, ";padding-inline:", function(props) {
    return props.paddingInlined;
}, ";.image-gallery{padding:24px 0;display:flex;justify-content:center;width:244px;.social-proof-gallery-picture{img{max-height:", LOGO_BIG_SCREEN_HEIGHT, "px;max-width:", LOGO_BIG_SCREEN_WIDTH - LOGO_WIDTH_TOTAL_PADDING, "px;}}}}&.slim.slim{.images-gallery-row{justify-content:flex-start;gap:32px;.image-gallery{padding:8px 0;width:auto;.social-proof-gallery-picture{img{max-height:", LOGO_SLIM_HEIGHT, "px;max-width:", LOGO_SLIM_WIDTH, "px;}}}}}&.new-layout{@media (max-width:", vp_sizes/* MID_HEADER_DESKTOP_MENU */.vc, "px){max-width:", vp_sizes.XS, "px;}@media (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px) and (min-width:", vp_sizes/* MID_HEADER_DESKTOP_MENU */.vc, "px){.images-logos-wrapper{.images-gallery{.images-gallery-row{.image-gallery{max-width:120px;.social-proof-gallery-picture{img{max-height:56px;max-width:96px;}}}}}}}.images-gallery-row{.image-gallery{width:", LOGO_BIG_SCREEN_WIDTH, "px;}}}@media (max-width:", vp_sizes/* MACBOOK_PRO_MAX_WIDTH */.Wh, "){&:not(.new-layout){.images-gallery-row{.image-gallery{padding:12px 0;margin:0 20px;width:170px;}}}&.slim.slim{.images-gallery-row{gap:24px;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MIN_WIDTH */.Lk, "){:not(.new-layout),.new-layout{margin-top:16px;.images-gallery-row{padding:0;.image-gallery{width:", LOGO_SMALL_SCREEN_WIDTH, "px;margin:0;padding:0 0 25px 0;.social-proof-gallery-picture{img{max-height:", LOGO_SMALL_SCREEN_HEIGHT, "px;max-width:", LOGO_SMALL_SCREEN_WIDTH - LOGO_WIDTH_TOTAL_PADDING, "px;}}}}.slim.slim{.images-logos-wrapper{max-width:300px;.images-gallery-row{.image-gallery{margin:0;width:unset;.social-proof-gallery-picture{img{max-height:48px;max-width:92px;}}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/logos/logos.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}











var Logos = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(Logos, PureComponent);
    var _super = (0,_create_super/* default */.Z)(Logos);
    function Logos(props) {
        (0,_class_call_check/* default */.Z)(this, Logos);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "isNewLayout", function() {
            return _this.getNumberOfCompaniesToDisplay() == logos_const/* NUMBER_OF_COMPANIES */.X$; // compare string and int (old props can be integers)
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getNumberOfCompaniesToDisplay", function() {
            var numberOfCompanies = _this.props.numberOfCompanies;
            if (logos_const/* SUPPORTED_LOGOS_NUMBER_OPTIONS.includes */.ly.includes(numberOfCompanies === null || numberOfCompanies === void 0 ? void 0 : numberOfCompanies.toString())) return numberOfCompanies;
            return logos_const/* NUMBER_OF_COMPANIES */.X$; // support old pages config which had companyNummber = 3, 8  + use this as the default prop when numberOfCompanies isn't defined
        });
        _this.state = {
            mobileView: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(Logos, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (window.matchMedia(vp_sizes/* MOBILE_QUERY */.lF).matches) {
                    this.setState({
                        mobileView: true
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, grayscale = _props.grayscale, showAllLogos = _props.showAllLogos, companyField = _props.companyField, country = _props.country, slim = _props.slim, personalizeUsingVisitorCountry = _props.personalizeUsingVisitorCountry, cloudfrontViewerCountry = _props.cloudfrontViewerCountry, abTests = _props.abTests, logosScale = _props.logosScale, useSingleLine = _props.useSingleLine, paddingInlined = _props.paddingInlined, maxWidth = _props.maxWidth;
                var assets = (0,logos_const/* getCompaniesAssets */.yA)({
                    companyField: companyField,
                    country: country,
                    personalizeUsingVisitorCountry: personalizeUsingVisitorCountry,
                    cloudfrontViewerCountry: cloudfrontViewerCountry,
                    abTests: abTests
                });
                var numberOfCompaniesToDisplay = this.getNumberOfCompaniesToDisplay();
                var companiesAssetsSliced = showAllLogos ? assets : assets.slice(0, numberOfCompaniesToDisplay);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogos, {
                    className: classnames_default()("logos", {
                        "full-logo-list": showAllLogos,
                        "new-layout": this.isNewLayout(),
                        slim: slim
                    }),
                    logosScale: logosScale,
                    useSingleLine: useSingleLine,
                    paddingInlined: paddingInlined,
                    maxWidth: maxWidth,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "images-logos-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(images_gallery_component/* default */.Z, {
                            grayscale: grayscale,
                            assets: companiesAssetsSliced,
                            shouldTrackMouseEvents: true
                        })
                    })
                });
            }
        }
    ]);
    return Logos;
}(react.PureComponent);
Logos.defaultProps = default_props/* default */.Z;
/* harmony default export */ var logos = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(Logos)));


/***/ }),

/***/ 80569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ hubspot_and_logos_form_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset.js
var side_by_side_text_and_asset = __webpack_require__(59526);
// EXTERNAL MODULE: ./segments/desktop/core-components/hubspot-contact-form/hubspot-contact-form.js + 2 modules
var hubspot_contact_form = __webpack_require__(78235);
// EXTERNAL MODULE: ./segments/desktop/core-components/hubspot-contact-form/default-props.js
var default_props = __webpack_require__(95472);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./segments/desktop/core-components/logos/logos.js + 1 modules
var logos_logos = __webpack_require__(89206);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/default-props.js
var full_paragraph_default_props = __webpack_require__(7484);
// EXTERNAL MODULE: ./segments/desktop/core-components/logos/default-props.js
var logos_default_props = __webpack_require__(49281);
;// CONCATENATED MODULE: ./segments/desktop/core-components/paragraph-and-logos/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var fullParagraphDefaultProps = _object_spread_props(_object_spread({}, full_paragraph_default_props/* default */.Z), {
    topic: {},
    title: "Trusted by <monday-paying-companies />+ customers worldwide",
    textAlign: "center",
    body: ""
});
/* harmony default export */ var paragraph_and_logos_default_props = ({
    marginBetweenParagraphAndLogos: "24px",
    logosMaxWidth: null,
    fullParagraph: fullParagraphDefaultProps,
    logos: logos_default_props/* default */.Z
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/paragraph-and-logos/paragraph-and-logos.scss.js

var StyledParagraphAndLogos = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ev5e7k40"
})("display:flex;flex-direction:column;align-items:center;.paragraph-wrapper{}.logos-wrapper{}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/paragraph-and-logos/paragraph-and-logos.js
function paragraph_and_logos_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function paragraph_and_logos_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            paragraph_and_logos_define_property(target, key, source[key]);
        });
    }
    return target;
}






var ParagraphAndLogos = function(props) {
    var fullParagraph = props.fullParagraph, logos = props.logos, marginBetweenParagraphAndLogos = props.marginBetweenParagraphAndLogos, logosMaxWidth = props.logosMaxWidth;
    var logosWrapperStyle = (0,react.useMemo)(function() {
        return {
            marginTop: marginBetweenParagraphAndLogos,
            maxWidth: logosMaxWidth
        };
    }, [
        marginBetweenParagraphAndLogos,
        logosMaxWidth
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledParagraphAndLogos, {
        className: "paragraph-and-logos",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "paragraph-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, paragraph_and_logos_object_spread({}, fullParagraph))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "logos-wrapper",
                style: logosWrapperStyle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logos_logos/* default */.Z, paragraph_and_logos_object_spread({}, logos))
            })
        ]
    });
};
/* harmony default export */ var paragraph_and_logos = (ParagraphAndLogos);
ParagraphAndLogos.defaultProps = paragraph_and_logos_default_props;

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-and-logos-form/hubspot-and-logos-form-component.scss.js


var StyledHubspotAndLogosFormComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e16rzq0l0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;");

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-and-logos-form/hubspot-and-logos-form-component.js
function hubspot_and_logos_form_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hubspot_and_logos_form_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hubspot_and_logos_form_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function hubspot_and_logos_form_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function hubspot_and_logos_form_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        hubspot_and_logos_form_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var NINE_LOGOS_MAX_WIDTH = "590px";
var HubspotAndLogosFormComponent = function(props) {
    var formId = props.formId, source = props.source, overrideCampaignId = props.overrideCampaignId, paragraphAndLogos = props.paragraphAndLogos, lastNameFirst = props.lastNameFirst, bookAMeetingFlowUrl = props.bookAMeetingFlowUrl, bamTimeout = props.bamTimeout, enableLoader = props.enableLoader, restProps = _object_without_properties(props, [
        "formId",
        "source",
        "overrideCampaignId",
        "paragraphAndLogos",
        "lastNameFirst",
        "bookAMeetingFlowUrl",
        "bamTimeout",
        "enableLoader"
    ]);
    var replaceTextComponentProps = {
        formId: formId,
        bookAMeetingFlowUrl: bookAMeetingFlowUrl,
        bamTimeout: bamTimeout,
        enableLoader: enableLoader,
        source: source,
        overrideCampaignId: overrideCampaignId,
        lastNameFirst: lastNameFirst
    };
    var replaceAssetComponentProps = (0,react.useMemo)(function() {
        var _paragraphAndLogos_logos;
        if ((paragraphAndLogos === null || paragraphAndLogos === void 0 ? void 0 : (_paragraphAndLogos_logos = paragraphAndLogos.logos) === null || _paragraphAndLogos_logos === void 0 ? void 0 : _paragraphAndLogos_logos.numberOfCompanies) === "9") {
            paragraphAndLogos.logosMaxWidth = NINE_LOGOS_MAX_WIDTH;
        }
        return hubspot_and_logos_form_component_object_spread({}, paragraphAndLogos);
    }, [
        paragraphAndLogos
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHubspotAndLogosFormComponent, {
        className: "hubspot-and-logos-form-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset/* default */.Z, hubspot_and_logos_form_component_object_spread_props(hubspot_and_logos_form_component_object_spread({
            replaceTextComponent: hubspot_contact_form/* default */.Z
        }, restProps), {
            replaceTextComponentProps: replaceTextComponentProps,
            replaceAssetComponent: paragraph_and_logos,
            replaceAssetComponentProps: replaceAssetComponentProps
        }))
    });
};
/* harmony default export */ var hubspot_and_logos_form_component = (HubspotAndLogosFormComponent);
HubspotAndLogosFormComponent.defaultProps = hubspot_and_logos_form_component_object_spread_props(hubspot_and_logos_form_component_object_spread({
    width: "100%"
}, default_props/* default */.Z), {
    paragraphAndLogos: paragraph_and_logos.defaultProps
});


/***/ })

}]);